import { PropTypes } from 'prop-types';
import React from 'react';

import ArrowCircleFill from '../../assets/svg/arrow-circle-fill.svg';
import ArrowCircleFillAngled from '../../assets/svg/arrow-circle-fill-angled.svg';
import Link from '../Link';

const TitleStrip = ({ description, link, title, variant }) => {
  return (
    <div className="py-6 border-b sm:py-8 lg:py-14 border-smoke">
      <div className="global-padding-container">
        <div className="flex items-center justify-between">
          {!variant ? (
            <h2 className="stink-h2">{title}</h2>
          ) : (
            <h4 className="stink-h4">{title}</h4>
          )}

          <Link className="flex items-center" to={link.url}>
            <span
              className="mr-3 stink-body-3"
              data-component-id="title_strip_link"
            >
              {link.title}
            </span>
            {!variant ? (
              <ArrowCircleFill className="w-6 h-full lg:w-8" />
            ) : (
              <ArrowCircleFillAngled className="w-6 h-full lg:w-8" />
            )}
          </Link>
        </div>
        <div className="flex items-center mt-4">
          <p className="stink-h5">{description}</p>
        </div>
      </div>
    </div>
  );
};

TitleStrip.propTypes = {
  description: PropTypes.string,
  link: PropTypes.object,
  title: PropTypes.string,
  variant: PropTypes.bool,
};

export default TitleStrip;
